import { Col, Row } from 'antd';
import styles from './index.module.sass';
import { Requisite } from './components/requisite';
import classNames from 'classnames';
import { TabsBar } from '../../../common/components/tabs-bar';
import {
  Dispatch,
  SetStateAction,
  memo,
  useCallback,
  useEffect,
  useState,
} from 'react';
import { SettingsTab } from './components/settings-tab';
import { OffersTab } from './components/offers-tab';
import { useStore } from 'effector-react';
import {
  $buyerPointsLoadingStatus,
  $buyersData,
  $localDisabledBuyers,
  $selectedBuyerReceivingPoints,
  $singleBuyerData,
  fetchBuyersListFx,
  getBuyerPointsFx,
} from '../../store/buyers.store';
import { AddressNotifier } from './components/address-notifier/index.component';
import { PointsTab } from '@@/common/components/points-tab';
import { orderBy } from 'lodash-es';
import { StatsTab } from './components/stats-tab';
import { conformToMask } from 'react-text-mask';
import {
  $offersData,
  fetchBuyerOffersListFx,
  switchBuyerOffers,
} from '../../store/offers.store';
import md5 from 'md5';
import { useNavigate } from 'react-router-dom';
import { BuyerInstance } from '../../ts';
import { Sorter } from '@/modules/common/components/sorter';
import { SELLER_ACCOUNT_OFFERS_SORT } from '../../constants';

export const BuyerDetails = memo(
  ({
    setShowOfferModal,
    showOfferModal,
    sortOption,
    orderBy,
    searchString,
    searchActiveBuyer,
    setSearchString,
    refetchBuyersList,
  }: IBuyerDetails) => {
    const navigate = useNavigate();

    const localeDisabledBuyers = useStore($localDisabledBuyers);
    const buyerInfo = useStore($singleBuyerData);
    const buyersData = useStore($buyersData);
    const singleBuyerData = useStore($singleBuyerData);
    const receivingPoints = useStore($selectedBuyerReceivingPoints);
    const pointsLoading = useStore($buyerPointsLoadingStatus);
    const [activeTab, setActiveTab] = useState(0);
    const [pointModalVisible, setPointModalVisible] = useState(false);
    const offers = useStore($offersData);
    const [disableAll, setDisableAll] = useState(false);
    const offersSortFromLs = (() => {
      const val = localStorage.getItem(SELLER_ACCOUNT_OFFERS_SORT);
      const res = val ? JSON.parse(val) : null;
      return res;
    })();

    const data = searchActiveBuyer?.id ? searchActiveBuyer : buyersData?.data[0];
    const phoneNumber = data?.tel || buyerInfo?.tel;
    const isExternal = data?.type === 'external';
    const findFirstEnabled =
      receivingPoints.find((item) => item.enabled === 1) ||
      receivingPoints.find((item) => item.enabled === 0) ||
      undefined;
    const [offersSort, setOffersSort] = useState(
      offersSortFromLs || {
        order: 'desc',
        param: [
          { label: 'по сроку действия', val: 'deadline', active: false },
          { label: 'по стоимости предложения', val: 'price', active: false },
          { label: 'дате создания', val: 'creationDate', active: false },
          { label: 'по классу культуры', val: 'classN', active: false },
          { label: 'по дате изменения', val: 'editedDate', active: true },
        ],
      },
    );
    const tabs = !isExternal
      ? [
          {
            label: offers?.length ? `предложения (${offers?.length})` : 'предложения',
            id: 0,
          },
          {
            label: receivingPoints?.length
              ? `пункты приема (${receivingPoints?.length})`
              : 'пункты приема',
            id: 3,
          },
          { label: 'динамика цен', id: 1, disabled: false },
          { label: 'настройки', id: 2 },
        ]
      : [
          {
            label: offers?.length ? `предложения (${offers?.length})` : 'предложения',
            id: 0,
          },
          {
            label: receivingPoints?.length
              ? `пункты приема (${receivingPoints?.length})`
              : 'пункты приема',
            id: 3,
          },

          { label: 'динамика цен', id: 1, disabled: false },
          ,
        ];

    useEffect(() => {
      return () => {
        setActiveTab(0);
      };
    }, []);

    useEffect(() => {
      if (data?.id) {
        getBuyerPointsFx(data?.id);
        setActiveTab(0);
      }
    }, [data]);

    useEffect(() => {
      if (buyerInfo) {
        fetchOffers();
      }
    }, [buyerInfo]);

    useEffect(() => {
      let val = false;
      if (offers) {
        val = offers.some((item) => item.enabled === 1);
        setDisableAll(val);
      }
    }, [offers]);

    useEffect(() => {
      if (offersSort) {
        localStorage.setItem(SELLER_ACCOUNT_OFFERS_SORT, JSON.stringify(offersSort));
      }
    }, [offersSort]);

    const fetchOffers = () => {
      fetchBuyerOffersListFx({
        id: Number(buyerInfo?.id),
        md5: buyerInfo?.type === 'external' ? md5(buyerInfo?.company_name) : undefined,
      });
    };

    const reloadSidebarData = useCallback(
      async () =>
        await fetchBuyersListFx({
          sortBy: sortOption.find((item) => item.active)?.val,
          orderBy,
          search: searchString,
        }),
      [sortOption],
    );

    const formatAddress = (obj) => {
      if (!obj?.region) return ' - ';

      const parts = [
        obj.region ?? '',
        obj.city ?? '',
        obj.street ?? '',
        obj.house ?? '',
      ].filter((part) => part !== '');

      return parts.join(', ');
    };

    return (
      <>
        {data ? (
          <div className={styles.root}>
            <div className={styles.topInfo}>
              <h3 className={styles.buyerName}>{data.company_name}</h3>
              <span
                className={styles.buyerType}
                style={{ color: isExternal ? '#000' : '#409BFF' }}
              >
                {isExternal ? 'внешний контрагент' : 'ваш контрагент'}
              </span>
              {data?.enabled === 0 ||
              (data.id && localeDisabledBuyers.includes(data?.id)) ? (
                <div className={styles.comment}>
                  <span className={styles.marker}></span>
                  <span className={styles.commentText}>
                    предложения покупателя не учитываются при расчете системы
                  </span>
                </div>
              ) : (
                <div className={classNames(styles.comment, styles.activeComment)}>
                  <span className={styles.marker}></span>
                  <span className={styles.commentText}>
                    предложения покупателя учитываются при расчете системы
                  </span>
                </div>
              )}
            </div>
            {/* <div
            style={{
              margin: '20px 0px',
              display:
                !isExternal && !pointsLoading.loading && receivingPoints.length < 1
                  ? 'block'
                  : 'none',
            }}
          >
            
          </div> */}
            <Row
              gutter={[32, 16]}
              className={styles.cont}
              style={{ marginBottom: '32px' }}
            >
              <Col xxl={6} xl={12}>
                <Requisite
                  label="название компании"
                  tooltip={(data?.company_name || buyerInfo?.company_name).length > 30}
                  value={data?.company_name || buyerInfo?.company_name || ' - '}
                />
              </Col>
              <Col xxl={6} xl={12}>
                <Requisite
                  label="адрес компании"
                  tooltip={true}
                  value={data?.address || buyerInfo?.address || ' - '}
                />
              </Col>

              <Col xxl={6} xl={12}>
                <Requisite
                  label="телефон"
                  value={
                    phoneNumber
                      ? conformToMask(
                          phoneNumber,
                          [
                            '+',
                            '7',
                            ' ',
                            '(',
                            /[1-9]/,
                            /\d/,
                            /\d/,
                            ')',
                            ' ',
                            /\d/,
                            /\d/,
                            /\d/,
                            '-',
                            /\d/,
                            /\d/,
                            '-',
                            /\d/,
                            /\d/,
                          ],
                          { guide: false },
                        ).conformedValue
                      : ' - '
                  }
                />
              </Col>

              <Col xxl={6} xl={12}>
                <Requisite
                  label="e-mail"
                  value={data?.email || buyerInfo?.email || ' - '}
                />
              </Col>
              <Col xxl={6} xl={12}>
                <Requisite label="ИНН" value={data?.inn || buyerInfo?.inn || ' - '} />
              </Col>

              <Col xxl={6} xl={12}>
                <Requisite
                  label="ОГРН"
                  value={data?.ogrn || buyerInfo?.ogrn || ' - '}
                />
              </Col>

              <Col>
                <Requisite
                  label={
                    <span className={styles.pointsLink} onClick={() => setActiveTab(3)}>
                      адреса пунктов приема зерна
                    </span>
                  }
                  tooltip={true}
                  value={formatAddress(findFirstEnabled)}
                />
              </Col>

              {buyerInfo?.type === 'internal' &&
                !pointsLoading.loading &&
                receivingPoints.length < 1 && (
                  <AddressNotifier
                    label="Для расчета логистики необходимо заполнить адрес пункта приема зерна"
                    buttonText="заполнить"
                    onClick={() =>
                      activeTab === 3 ? setPointModalVisible(true) : setActiveTab(3)
                    }
                  />
                )}
            </Row>

            {activeTab === 0 && (
              <Sorter
                sortOption={offersSort.param}
                setSortOption={(options) =>
                  setOffersSort({ ...offersSort, param: options })
                }
                orderBy={offersSort.order as any}
                setOrderBy={(order) => setOffersSort({ ...offersSort, order })}
              />
            )}

            <TabsBar
              tabs={tabs as any}
              activeItem={activeTab}
              setActiveTab={setActiveTab}
              controls={
                activeTab === 0 ? (
                  <a
                    href="#"
                    onClick={async (e) => {
                      e.preventDefault();
                      await switchBuyerOffers({
                        id: Number(buyerInfo?.id),
                        type: data?.type || 'internal',
                        enabled: !disableAll,
                      });
                      await refetchBuyersList();
                      //await fetchBuyersListFx();
                      setDisableAll(!disableAll);
                    }}
                  >
                    {disableAll ? 'откл. все предложения' : 'вкл. все предложения'}
                    {/* вкл. все предложения */}
                  </a>
                ) : (
                  <></>
                )
              }
            />
            {!isExternal && activeTab === 2 ? (
              <SettingsTab
                sortOption={sortOption}
                orderBy={orderBy}
                setSearchString={setSearchString}
                searchString={searchString}
              />
            ) : activeTab === 0 ? (
              <OffersTab
                offersSort={offersSort}
                setShowOfferModal={setShowOfferModal}
                showOfferModal={showOfferModal}
                isExternal={isExternal}
                isBuyerEnabled={data?.enabled === 1 ? true : false}
                reloadSidebarFx={reloadSidebarData}
              />
            ) : activeTab === 3 ? (
              <PointsTab
                loadingStatus={pointsLoading}
                data={receivingPoints}
                buyerId={Number(data?.id)}
                modalVisible={pointModalVisible}
                setModalVisible={setPointModalVisible}
                pointsNotEditable={buyerInfo?.type === 'external'}
              />
            ) : activeTab === 1 ? (
              <StatsTab buyerId={Number(data?.id)} />
            ) : null}
          </div>
        ) : null}
      </>
    );
  },
);

interface IBuyerDetails {
  showOfferModal: boolean;
  setShowOfferModal: (val: boolean) => void;
  sortOption: { label: string; val: string; active: boolean }[];
  setSortOption: (val: { label: string; val: string; active: boolean }[]) => void;
  orderBy: 'asc' | 'desc';
  searchString: string;
  searchActiveBuyer: BuyerInstance | undefined;
  setSearchString: (val: string) => void;
  refetchBuyersList: () => Promise<BuyerInstance[] | undefined>;
}
